export const URL = process.env.REACT_APP_URL;
// export const URL = "http://localhost:49460/";
export const WEB_URL = process.env.REACT_APP_WEB_URL;
export const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY;
